<script setup>
import { useMiscStore } from '@/stores/misc';
import LikeButtonComponent from './LikeButtonComponent.vue';
import {MapPinIcon} from "@heroicons/vue/16/solid";
import TagComponent from "@/components/TagComponent.vue";
import CommentCountComponent from "@/components/shared/CommentCountComponent.vue";
import {computed} from "vue";

const misc = useMiscStore(),
 props = defineProps({
  layout: {
    default: false,
    type: Boolean,
  },
  showImage: {
    default: false,
    type: Boolean,
  },
  businesses: {
    default: () => [],
    type: Array,
  },
}),
// Normalize businesses data to always be an array
normalizedBusinesses = computed(() => {
  const businesses = props.businesses?.value || props.businesses || [];
  console.log('[PostList] Normalized businesses:', businesses);
  return Array.isArray(businesses) ? businesses : [];
}),

setCurrentSectorAndCategory = (sector, category) => {
  misc.setCurrentSector(sector);
  misc.setCurrentCategory(category);
};
</script>

<template>
  <div>
    <div
      v-if="normalizedBusinesses.length === 0"
      class="text-center py-8"
    >
      <p class="text-gray-500">
        No businesses to display
      </p>
      <p class="text-sm text-gray-400">
        Received data: {{ JSON.stringify(props.businesses) }}
      </p>
    </div>

    <ul
      v-else
      :class="[
        'list-none mt-4 mb-3',
        props.layout ? 'grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-4' : 'grid-cols-1',
      ]"
    >
      <li
        v-for="business in props.businesses"
        :key="business.id"
        :class="['border-0 p-0 rounded-xl ay-shadow shadow-md bg-white', props.layout ? 'mb-0' : 'mb-3']"
      >
        <div
          style="min-height: 230px; max-height: 230px; object-fit: cover;"
          :class="[
            'card-image-top link-image-preview rounded-t-xl relative overflow-hidden',
            props.showImage ? 'block' : 'hidden',
          ]"
        >
          <router-link
            :to="`/users/${business.creator.id}/${business.sector.slug.toLowerCase()}/${business.category.slug.toLowerCase()}/${
              business.id
            }`"
            target="_self"
            @click="
              setCurrentSectorAndCategory(business.sector, business.category)
            "
          >
            <span
              class="ay-overlay overlay-success absolute flex justify-center items-center top-0 bg-teal-950/50 w-full h-full"
              style="z-index: 1"
            />
            <img
              :src="business.baseImageUrl"
              :alt="business.name"
              class="rounded-t-xl w-full ay-img-scaled object-cover"
              style="height: 230px;"
              decoding="async"
              importance="low"
              :title="business.name"
              loading="lazy"
            >
          </router-link>
        </div>
        <div class="">
          <div class="flex flex-wrap">
            <div
              class="link-details px-4 pt-4 mb-2 flex justify-between flex-wrap w-full"
            >
              <div class="text-left text-xs mb-2 overflow-hidden whitespace-nowrap overflow-ellipsis">
                <MapPinIcon
                  id="bookmark"
                  data-toggle="tooltip"
                  class="h-4 w-4 text-center text-gray-400 cursor-pointer mr-0.5 inline"
                  aria-hidden="true"
                  style="cursor:pointer;"
                />
                <span class="text-gray-400">
                  {{ business?.region.name }}/{{ business.city.name }} -
                  {{ business.address }}
                </span>
              </div>
              <div class="w-full mt-1 mb-2">
                <h3
                  class="mb-2 h5 text-left overflow-hidden whitespace-nowrap overflow-ellipsis"
                >
                  <router-link
                    :to="`/users/${business.creator.id}/${business.sector.slug.toLowerCase()}/${business.category.slug.toLowerCase()}/${
                      business.id
                    }`"
                    target="_self"
                    class="text-gray-500 font-semibold hover:text-green-600 transition-all duration-500"
                    @click="
                      setCurrentSectorAndCategory(business.sector, business.category)
                    "
                  >
                    {{ business.name }}
                  </router-link>
                </h3>
              </div>
              <span class="text-gray-400 mr-md-2 text-xs"> {{ business.updatedAt }}</span>
              <router-link
                :to="{
                  name: 'UserBusinessCategory',
                  params: {
                    username: business.creator.id,
                    sector: business.sector.slug,
                    category: business.category.slug
                  }
                }"
                class="tag self-center"
                @click="setCurrentSectorAndCategory(business.sector, business.category)"
              >
                <TagComponent
                  :title="business.category?.name"
                  :class="`text-[10px] md:mt-2 rounded-lg px-1 py-[1.5px]`"
                  :bg-color="business.category?.background"
                  :color="business.category?.color"
                />
              </router-link>
            </div>
            <!--            <hr class="w-full"/>-->
            <!-- <div
                 class="px-4 w-full pt-2 pb-4 hidden xl:flex flex-wrap text-muted">
              <span class="text-xs">jsjkjs / skjskkjs</span>
              <span class="ml-1 text-xs">- etc</span>
            </div> -->
            <div class="w-full px-4 py-3 border-t">
              <div class="flex flex-col text-xs">
                <div class="flex flex-wrap justify-between items-center">
                  <div class="items-center flex flex-grow no-more">
                    <LikeButtonComponent
                      :id="business.id"
                      :count="business.likeCount"
                      :user-has-liked="business.liked"
                      from="contributor"
                    />
                    <CommentCountComponent
                      :id="business.id"
                      :count="business.reviewCount"
                      from="contributor"
                    />
                  </div>
                  <div class="flex-grow">
                    <router-link
                      class="flex items-center justify-between md:justify-end flex-grow"
                      :to="`/users/${business.creator.id}/businesses`"
                    >
                      <span>{{ business.creator.name }}</span>
                      <img
                        :src="business.creator.profile.avatar"
                        class="w-6 h-6 rounded-full mr-0 ml-2 text-success"
                        alt=""
                      >
                    </router-link>
                  </div>
                </div>
              </div>
              <!--          <span class="ay-overlay"></span> -->
            </div>
          </div>
        </div>
      </li>
      <!--      <li class="rounded border mb-3 p-1">-->
      <!--        <div class="media-body">-->
      <!--          No Contribution yet.-->
      <!--        </div>-->
      <!--      </li>-->
    </ul>
  </div>
</template>

<style scoped></style>
